import { CollapseProps, Collapse as MuiCollapse } from "@mui/material";

type Props = CollapseProps;

export const Collapse = ({ children, ...props }: Props) => {
  return <MuiCollapse {...props}>{children}</MuiCollapse>;
};
